import React, { useState, useEffect } from 'react';
import candyIcon from '../../assets/icons/candy.webp';
import dropsIcon from '../../assets/icons/drops.webp';
import hempIcon from '../../assets/icons/hemp.webp';
import spiceIcon from '../../assets/icons/spice.webp';
import lsdIcon from '../../assets/icons/lsd.webp';
import pillsIcon from '../../assets/icons/pills.webp';
import powderIcon from '../../assets/icons/powder.webp';
import shroomIcon from '../../assets/icons/shroom.webp';
import xtalIcon from '../../assets/icons/xtal.webp';
import SubstanceInfo from './SubstanceInfo'; // Importuj komponent do wyświetlania szczegółów substancji
import { getSubstances } from '../../services/megamix'; // Importuj getSubstances, aby uzyskać listę substancji
import { List, ListItem } from 'react-onsenui';

const icons = [
  { name: 'Powder', file: powderIcon },
  { name: 'Crystal', file: xtalIcon },
  { name: 'Pill', file: pillsIcon },
  { name: 'Blotter', file: lsdIcon },
  { name: 'Edible', file: candyIcon },
  { name: 'Liquid', file: dropsIcon },
  { name: 'Flower', file: hempIcon },
  { name: 'Herb', file: spiceIcon },
  { name: 'Mushroom', file: shroomIcon },
];

const optionsMap = {
  Powder: ['2C-B', 'Amphetamine', 'Benzodiazepine', 'Cocaine', 'DMT', 'Ketamine', 'LSD', 'MDMA', 'MDA', 'Mephedrone', 'Methamphetamine', 'Opioid', 'Other'],
  Crystal: ['DMT', 'Ketamine', 'LSD', 'MDMA', 'MDA', 'Mephedrone', 'Methamphetamine', 'Other'],
  Pill: ['2C-B', 'Amphetamine', 'Benzodiazepine', 'LSD', 'MDMA', 'MDA', 'Mephedrone', 'Methamphetamine', 'Opioid', 'Other'],
  Blotter: ['2C-B', 'LSD', 'Opioid', 'Other'],
  Edible: ['LSD', 'MDMA', 'MDA', 'THC', 'Other'],
  Liquid: ['Ketamine', 'LSD', 'THC', 'Other'],
  Flower: ['THC', 'Other'],
  Herb: ['DMT', 'THC', 'Other'],
  Mushroom: ['Psilocybin', 'Other'],
};

const substancesWithMagnifyingGlass = [
  '2C-B', 'Amphetamine', 'Benzodiazepine', 'Cocaine', 'DMT', 'Ketamine',
  'LSD', 'MDMA', 'MDA', 'Mephedrone', 'Methamphetamine', 'Opioid', 'THC', 'Looks', 'At'
];

const renderTableRow = (text, link, selectedIcon = null) => {
  const startsWithSubstance = substancesWithMagnifyingGlass.some(substance => text.startsWith(substance));

  let icon;
  if (startsWithSubstance) {
    icon = 'fa-search';
  } else if (text.startsWith('To identify the presence')) {
    icon = 'fa-vial';
  } else if (text.startsWith('To rule out fentanyl')) {
    icon = 'fa-flask';
  } else if (text.startsWith('To estimate potency')) {
    icon = 'fa-microscope';
  }

  let additionalMessage = '';
  if (selectedIcon) {
    switch (selectedIcon) {
      case 'Powder':
        additionalMessage = ' Only 3-5 mg are required for a single test.';
        break;
      case 'Crystal':
        additionalMessage = ' Only 3-5 mg are required for a single test.';
        break;
      case 'Pill':
        additionalMessage = ' Only a few scraped off miligrams are required for a single test.';
        break;
      case 'Blotter':
        additionalMessage = ' 1/4 of a tab is recommended per test, but 1/8th should work too.';
        break;
      case 'Edible':
        additionalMessage = ' It might be required to extract the active compound from sample.';
        break;
      case 'Liquid':
        additionalMessage = ' Use a single drop of your sample per test.';
        break;
      case 'Flower':
        additionalMessage = ' Only 3-5 mg are required for a single test.';
        break;
      case 'Herb':
        additionalMessage = ' Only 3-5 mg are required for a single test.';
        break;
      // case 'Mushroom':
      //   additionalMessage = ' This substance is commonly found on blotters.';
        // break;
      // Dodaj inne przypadki w zależności od potrzeb
      default:
        additionalMessage = '';
    }
  }

  return (
    <tr>
      <td style={{ width: '50px', textAlign: 'center', verticalAlign: 'middle' }}>
        <i className={`fas ${icon}`} style={{ fontSize: '20px', verticalAlign: 'middle' }}></i>
      </td>
      <td style={{ verticalAlign: 'middle', padding: '10px 0' }}>
        {text}{additionalMessage}{' '}
        {link && (
          <a href={link} target="_blank" rel="noopener noreferrer">
            (available here)
          </a>
        )}
        {startsWithSubstance && (
          <>
            {'Looks, smell or taste are not reliable testing methods. '}
            <a href="https://protestkit.eu/alerts" target="_blank" rel="noopener noreferrer">
              (compare lab results here)
            </a>
          </>
        )}
      </td>
    </tr>
  );
};



const contentMap = {
  '2C-B': (selectedIcon) => (
    <>
      <h2 style={{marignTop: 0}}>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('2C-B is usually off-white or tan, but so are many other compounds.', null)}
      {renderTableRow('To identify the presence of 2C-B start with a reagent test.', 'https://protestkit.eu/2cb-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_category=tlc-test-kits')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  Amphetamine: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('Amphetamine is usually white, but so are many other compounds.', null)}
      {renderTableRow('To identify the presence of amphetamine start with a reagent test.', 'https://protestkit.eu/amphetamine-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/amphetamine-purity-test-kit-tlc/')}
        <div style={{padding: '20px'}}>
  <p>
    For more information use the search function. Testing guides are available in the Help section in our website's menu. 
    Reference photos are available <a href="/photos" target="_blank" rel="noopener noreferrer">here</a> and videos are available 
    <a href="/videos" target="_blank" rel="noopener noreferrer">here</a>.
  </p>
</div>        </div>
    </>
  ),
  Benzodiazepine: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('Benzodiazepines are usually white, but so are many other compounds.', null)}
      {renderTableRow('To identify the presence of a benzodiazepine start with a reagent test kit.', 'https://protestkit.eu/benzodiazepines-test-kit/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  Cocaine: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('Cocaine is usually white and has a numbing effect, just like many other compounds.', null)}
      {renderTableRow('To identify the presence of cocaine start with a reagent test.', 'https://protestkit.eu/cocaine-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/cocaine-purity-test-kit-tlc/')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  DMT: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('DMT is usually white when pure, just like many other compounds.', null)}
      {renderTableRow('To identify the presence of DMT start with a reagent test.', 'https://protestkit.eu/dmt-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_category=tlc-test-kits')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  Ketamine: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('Ketamine usually has white or clear needle or sugar shaped crystals, just like many other compounds.', null)}
      {renderTableRow('To identify the presence of ketamine start with a reagent test.', 'https://protestkit.eu/ketamine-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_category=tlc-test-kits')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>
      </div>
    </>
  ),
  LSD: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('LSD is known for a metallic aftertaste and does not have a smell, just like many other compounds.', null)}
      {renderTableRow('To identify the presence of LSD start with a reagent test.', 'https://protestkit.eu/lsd-single/', selectedIcon)}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/lsd-purity-test-kit-tlc/')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  MDMA: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('MDMA is usually white or brownish and has an anise smell, but so do other compounds.', null)}
      {renderTableRow('To identify the presence of MDMA start with a reagent test.', 'https://protestkit.eu/mdma-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/mdma-purity-test-kit-tlc/')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  MDA: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('MDA is usually white or brownish and has an anise smell, but so do other compounds.', null)}
      {renderTableRow('To identify the presence of MDA start with a reagent test.', 'https://protestkit.eu/mdma-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/mdma-purity-test-kit-tlc/')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  Mephedrone: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('Mephedrone is usually clear or white, just like many other compounds.', null)}
      {renderTableRow('To identify the presence of mephedrone start with a reagent test kit.', 'https://protestkit.eu/mephedrone-reagent-test-kit/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/mephedrone-purity-test-kit-tlc/')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  Methamphetamine: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('Methamphetamine is usually clear or white, just like many other compounds.', null)}
      {renderTableRow('To identify the presence of methamphetamine start with a reagent test.', 'https://protestkit.eu/amphetamine-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_category=tlc-test-kits')}
        <div style={{padding: '20px'}}>
  <p>
      </p>For more information scroll below or use the search function.
</div>        </div>
    </>
  ),
  Opioid: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('Opioids when pure are usually white, just like many other compounds.', null)}
      {renderTableRow('To identify the presence of an opioid start with a reagent test.', 'https://protestkit.eu/opioids-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  THC: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
      {renderTableRow('THC usually comes on cannabis flowers, which can be recognized by pistils ("hair") and trichomes (glands). But so do synthetic cannabinoids on adulterated hemp.', null)}
      {renderTableRow('To identify the presence of THC start with a reagent test.', 'https://protestkit.eu/cannabis-single/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/cannabinoids-test-kit-tlc/')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  ),
  Psilocybin: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
        {renderTableRow('At the moment the only simple recommended reliable method of confirming presence of psilocybin is checking for blue bruising (sign of oxidated psilocin).', null)}
        <div style={{padding: '20px'}}>
  <p>
    For more information <a href="/how-to-test-psilocybin-magic-mushrooms/" target="_blank" rel="noopener noreferrer"> click here</a>.
  </p>
</div>      </div>
    </>
  ),
  Other: (selectedIcon) => (
    <>
      <h2>Testing recommendations</h2>
      <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: '600px' }}>
        {renderTableRow('Consider getting tools for objective assesment, not personal opinions.', null)}
        {renderTableRow('To identify the presence of a substance start with a reagent test.', 'https://protestkit.eu/single-reagents/', selectedIcon)}
        {renderTableRow('To rule out fentanyl, nitazenes, or xylazine, consider getting a test strip.', 'https://protestkit.eu/shop/?wpf=sidebar&wpf_page=1&wpf_category=test-strips')}
        {renderTableRow('To estimate potency and rule out any cut, pair reagents with a TLC purity test kit.', 'https://protestkit.eu/tlc-test-kits/')}
        <div style={{padding: '20px'}}>
  <p>
    For more information scroll below or use the search function.  </p>
</div>        </div>
    </>
  )
};

export default function Wizard({ onReset }) {
  const [selectedIcon, setSelectedIcon] = useState(null); // Track selected icon
  const [showSearch, setShowSearch] = useState(false); // Toggle search screen
  const [dropdownValue, setDropdownValue] = useState(''); // Track dropdown value
  const [showFinal, setShowFinal] = useState(false); // Toggle final screen
  const [substances, setSubstances] = useState([]);
  const [selectedSubstance, setSelectedSubstance] = useState(null);

  useEffect(() => {
    const fetchedSubstances = getSubstances(); // Pobierz substancje z serwisu
    setSubstances(fetchedSubstances); // Ustaw substancje w stanie
  }, []);

  const resetWizard = () => {
    setSelectedIcon(null);
    setShowSearch(false);
    setDropdownValue('');
    setShowFinal(false);
    setSelectedSubstance(null);
  };

  useEffect(() => {
    if (onReset) {
      onReset(resetWizard);
    }
  }, [onReset]);

// Nasłuchuj na zmiany w historii przeglądarki
useEffect(() => {
  const handlePopState = () => {
    const params = new URLSearchParams(window.location.search);
    const category = params.get('category');
    const substance = params.get('substance');

    if (category) {
      setSelectedIcon(category);
      setShowSearch(true); // Pokaż ekran wyszukiwania
    } else {
      resetWizard();
    }

    if (substance) {
      setDropdownValue(substance);
      setShowFinal(true); // Pokaż finalny ekran
    } else {
      setShowFinal(false);
    }
  };

  // Nasłuchiwanie na zdarzenie "popstate"
  window.addEventListener('popstate', handlePopState);

  // Oczyszczanie zdarzeń po odmontowaniu komponentu
  return () => {
    window.removeEventListener('popstate', handlePopState);
  };
}, []);

const handleIconClick = (icon) => {
  setSelectedIcon(icon.name);
  document.querySelector('.icon-grid').classList.add('fade-out');
  setTimeout(() => {
    setShowSearch(true);

    // Aktualizuj URL z wybraną ikoną
    const newPathname = `${window.location.pathname}?category=${icon.name}`;
    window.history.pushState({ category: icon.name }, '', newPathname);

  }, 500); // Delay to trigger search screen
};

const handleDropdownChange = (e) => {
  const selectedOption = e.target.value;
  setDropdownValue(selectedOption);

  const substance = substances.find(sub => sub.commonName === selectedOption);
  setSelectedSubstance(substance);

  document.querySelector('.search-section').classList.add('fade-out');
  setTimeout(() => {
    setShowSearch(false);
    setShowFinal(true);

    // Aktualizuj URL z wybraną substancją
    const newPathname = `${window.location.pathname}?category=${selectedIcon}&substance=${selectedOption}`;
    window.history.pushState({ category: selectedIcon, substance: selectedOption }, '', newPathname);

  }, 500);
};


  return (
    <div style={{ textAlign: 'center' }}>
      {!showSearch && !showFinal ? (
        <div className={`icon-grid`}>
  <div style={{padding:'10px'}}><h2>Choose substance</h2></div>
  <div className="grid-container">
    {icons.map((icon) => (
      <div key={icon.name} className="grid-item" onClick={() => handleIconClick(icon)}>
        <img src={icon.file} alt={icon.name} style={{ width: '75px', height: '75px' }} />
        <p>{icon.name}</p>
      </div>
    ))}
  </div>
</div>
      ) : showSearch ? (
        <div className={`search-section fade-in`}>
          <h2 style={{ padding: '0px 70px' }}>What active ingredient do you expect?</h2>
          <List
  dataSource={optionsMap[selectedIcon]}
  renderRow={(option) => (
    <ListItem
      key={option}
      tappable
      onClick={() => handleDropdownChange({ target: { value: option } })}
    >
      <div className="substance-index-listitem-header clickable">
        <div className="testdrugs-header">{option}</div>
      </div>
    </ListItem>
  )}
/>

        </div>
      ) : showFinal ? (
        <div className={`final-section fade-in`}>
{contentMap[dropdownValue] ? contentMap[dropdownValue](selectedIcon) : contentMap['Other'](selectedIcon)}
          {selectedSubstance && (
            <div>
              <SubstanceInfo substance={selectedSubstance} />
            </div>
          )}
        </div>
      ) : null}

      <style jsx>{`
          .grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* Stała liczba kolumn: 3 */
    // gap: 20px; /* Podstawowy odstęp między elementami */
    justify-content: center; /* Wyśrodkowanie siatki w poziomie */
    align-content: center; /* Wyśrodkowanie siatki w pionie */
    // padding: 20px;
    height: 100%; /* Upewnij się, że siatka zajmuje całą dostępną wysokość */

  }

  .grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    gap: 10px; /* Podstawowy odstęp między elementami */

  }

  @media (min-width: 768px) {
    .grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Stała liczba kolumn: 3 */
  gap: 20px; /* Odstępy między elementami */
  padding: 20px;
  height: 100%;
  width: 500px; /* Stała szerokość */
  margin: 0 auto; /* Wyśrodkowanie kontenera */      
    }
  }
        
  .icon-grid {
    opacity: 1;
    transition: opacity 0.5s ease-out;
  }

  .icon-grid.fade-out {
    opacity: 0;
  }

  .search-section, .final-section {
    min-height: 400px;
    padding: 20px;
    opacity: 0;
    transition: opacity 0.5s ease-out;
  }

  .search-section.fade-in, .final-section.fade-in {
    opacity: 1;
  }

  .search-section.fade-out, .final-section.fade-out {
    opacity: 0;
  }

        .pulsing-question {
          font-size: 100px;
          color: #000;
          animation: pulse 1.5s infinite;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.2);
            opacity: 0.7;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}